"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isSharedFolder(folderId) {
    /* TODO: 1604 add sharedFolders into react */
    return false;
}
exports.default = isSharedFolder;
//# sourceMappingURL=isSharedFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/utils/isSharedFolder.js
// module id = 3285
// module chunks = 20 62